import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { GetCustomerTransactionsData } from '@common/types/payment';
import { UserProfile } from 'src/app/model/userProfile.model';
import { FirebaseApiService } from 'src/app/service/firebase-api.service';

@Component({
  selector: 'app-bill-usage',
  templateUrl: './bill-usage.component.html',
  styleUrls: ['./bill-usage.component.css']
})
export class BillUsageComponent implements OnInit, OnChanges {
  @Input() user: UserProfile;

  payments: GetCustomerTransactionsData = [];
  constructor(
    private firebaseApiService: FirebaseApiService
  ) {
  }

  ngOnInit(): void {
    this.getCustomerPayments();
  }

  ngOnChanges() {
    this.getCustomerPayments();
  }

  getCustomerPayments() {
    if (this.user && this.user.stripeId) {
      this.firebaseApiService.getCustomerPayments({
        stripeCustomerId: this.user.stripeId
      })
        .subscribe(payments => {
          this.payments = payments;
        });
    }
  }
}
